// ears are cutout_width + (overall_width - cutout_width) + (2 * ear_padding)
// typically this equals 1 1/2"
export const COMPONENT_EAR_PADDING = 0.0625;

// export const COMPONENT_CATEGORY_DROP_IN = 'drop-in';
// export const COMPONENT_CATEGORY_FRIDGE = 'fridge';
// export const COMPONENT_CATEGORY_VENT = 'vent';

export const COMPONENT_CATEGORIES_BOUND_TO_GROUND = ['logs', 'fridge'];

export const COMPONENT_PLACEMENT_FRONT_ONLY = 'front only';
export const COMPONENT_PLACEMENT_TOP_ONLY = 'top only';
export const COMPONENT_PLACEMENT_FRONT_AND_TOP = 'front and top';
export const COMPONENT_PLACEMENT_BOTTOM_ONLY = 'bottom only';


export const COMPONENT_APPLICATION_STAND_ALONE = 'stand-alone';
